import { TicketIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

export const CONVERSATION_CONCEPTS: { icon: typeof TicketIcon; term: string; description: string; iconWrap: string }[] = [
  {
    icon: TicketIcon,
    term: `Conversation`,
    description: `The ongoing conversation with one customer about a single topic — like an overdue invoice. It stays open across replies until it's resolved.`,
    iconWrap: `bg-blue-50 text-blue-600`,
  },
  {
    icon: WrenchScrewdriverIcon,
    term: `Tools & Approvals`,
    description: `Actions the agent can take on a conversation — emailing or texting the customer, sending a statement, or adding notes. Sensitive actions wait for your approval before they happen.`,
    iconWrap: `bg-amber-50 text-amber-600`,
  },
];

export const CONVERSATION_CONCEPTS_STORAGE_KEY = `agents_conversations_help_open`;

export const SHOW_RUNS = false;

export const RESOLVE_CHECK_TERMINAL_RUN_STATUSES = new Set([
  `completed`,
  `succeeded`,
  `failed`,
  `awaiting_input`,
  `awaiting_approval`,
]);

export const STATEMENT_DEFAULT_SUBJECT = `Your account statement`;

export const STATEMENT_DEFAULT_BODY = `Please find your latest account statement attached.`;

export const EDITABLE_FIELDS_BY_TOOL: Record<string, Array<`subject` | `body`>> = {
  send_email_to_customer: [ `subject`, `body` ],
  resend_invoice_email: [ `subject`, `body` ],
  send_sms_to_customer: [ `body` ],
  send_statement: [ `subject`, `body` ],
};
